/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/DataInput/dataCollectionTemplate.ts.
 */

export const DATA_COLLECTION_TEMPLATE = {
  href: "/file/CARBSE_ICoMEC_Contributor_Material_Import_Template_14Jul2026.xlsx",
  downloadName: "CARBSE_ICoMEC_Contributor_Material_Import_Template_14Jul2026.xlsx",
  label: "Download Excel template",
} as const;
